import React, {Component} from 'react';
import '../assets/teachers.css';
import {connect} from "react-redux";
import {Modal} from "react-bootstrap";
import closeModalIcon from '../assets/images/ico-close.png';
import warningIcon from '../assets/images/ico-warning.png';
import surveyIcon1 from '../assets/images/survey/survey1.png';
import surveyIcon2 from '../assets/images/survey/survey2.png';
import surveyIcon3 from '../assets/images/survey/survey3.png';
import surveyIcon4 from '../assets/images/survey/survey4.png';
import surveyIcon5 from '../assets/images/survey/survey5.png';
import logo_avepm from '../assets/images/logo_avenuepm.png';
import logo_maze from '../assets/images/logo_maze.png';
import logo_kidspeak from '../assets/images/logo_kidspeak.png';
import logo_picturenaming from '../assets/images/app-picturenaming.png';
import logo_wordsignsay from '../assets/images/app-wordsignsay.png';
import logo_kidsign from '../assets/images/app-kidsign.png';
import logo_copyright from '../assets/images/app-copyright.png';
import logo_slashtest from '../assets/images/logo_slashtest.png';
import logo_wordmark from '../assets/images/logo_wordmark.png';
import fourUngradedWarning from '../assets/images/pending_scoring_female.png';
import instructionImage from '../assets/images/rotate_device_fff_bg.png';
import TRACKING from "../Shared/DataTrackingPoints";
import REST from "./REST";
import {updateStudentAppsStatus, updateFirstLogin} from "../StudentsComponent/actions";

const DialogBox = class DialogBoxComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            surveyContent: null,
            surveyLogo:null,
            surveyInitialFrequency: null,
            surveyFrequency: null,
            isModalOpen: this.props.modalOpen ? this.props.modalOpen : false,
            analytics: {
                type: null,
                metadata: null,
            }
        }

        this.closeModal = this.closeModal.bind(this);
        this.handleYes = this.handleYes.bind(this);
        this.handleNo = this.handleNo.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.setupSurveyModal = this.setupSurveyModal.bind(this);
    }

    async componentDidMount() {
        if(this.props.surveyModal) {
            if(this.props.active){
                await this.setupSurveyModal();
            }
        }else{
            await this.setState({isModalOpen: this.props.modalOpen ? this.props.modalOpen : false})
        }
    }

    async setupSurveyModal(){
        if (this.props.app === 'Homepage') {
            await this.setState({surveyContent: 'I like AvePM.'});
        } else {
            await this.setState({surveyContent: 'I like ' + this.props.app + '.'});
        }
        switch(this.props.app){
            case 'Homepage':
                await this.setState({surveyLogo: logo_avepm });//every month
                break;
            case 'Maze':
                await this.setState({surveyLogo: logo_maze, surveyInitialFrequency:5, surveyFrequency:20});//5, 20
                break;
            case 'Slash':
                await this.setState({surveyLogo: logo_slashtest, surveyInitialFrequency:5, surveyFrequency:50});//5, 50
                break;
            case 'WordMark':
                await this.setState({surveyLogo: logo_wordmark, surveyInitialFrequency:5, surveyFrequency:10});//5, 10
                break;
            case 'KidSpeak':
                await this.setState({surveyLogo: logo_kidspeak, surveyInitialFrequency:5, surveyFrequency:10});//5, 10
                break;
            case 'Picture Naming':
                await this.setState({surveyLogo: logo_picturenaming, surveyInitialFrequency:5, surveyFrequency:9999});//5, 9999
                break;
            case 'Picture Naming (Computer Task)':
                await this.setState({surveyLogo: logo_picturenaming, surveyInitialFrequency:5, surveyFrequency:9999});//5, 9999
                break;
            case 'Picture Naming (1-1 Computer Task)':
                await this.setState({surveyLogo: logo_picturenaming, surveyInitialFrequency:5, surveyFrequency:9999});//5, 9999
                break;
            case 'Word Sign/Say':
                await this.setState({surveyLogo: logo_wordsignsay, surveyInitialFrequency:3, surveyFrequency:9999});//3, 9999
                break;
            case 'CopyRight':
                await this.setState({surveyLogo: logo_copyright, surveyInitialFrequency:5, surveyFrequency:15});//5, 15
                break;
            case 'KidSign':
                await this.setState({surveyLogo: logo_kidsign, surveyInitialFrequency:5, surveyFrequency:10});//5, 10
                break;
        }

        await REST.checkStudentData(this.props.userId, this.props.app).then(async res => {
            if (this.props.app === 'Homepage'){
                let lastLogins = res.body;
                let lastLogin = new Date(lastLogins[1].createdAt);
                let currentLogin = new Date(lastLogins[0].createdAt);
                if ((lastLogin.getFullYear() !== currentLogin.getFullYear())||(lastLogin.getMonth() !== currentLogin.getMonth())) {
                    await this.setState({isModalOpen: true});
                }else{
                    this.props.surveyBack();
                }
            }else{
                console.log('PopupSurvey: '+this.props.app+', test amount: ' + res.body);
                console.log('Result:' + (res.body-this.state.surveyInitialFrequency)%this.state.surveyFrequency);
                if (res.body === this.state.surveyInitialFrequency || (res.body-this.state.surveyInitialFrequency)%this.state.surveyFrequency === 0) {
                    await this.setState({isModalOpen: true});
                }
            }
        });

    }

    async componentDidUpdate(prevProps) {
        if(prevProps !== this.props) {
            if(this.props.surveyModal && this.props.active){
                    console.log('setupSurveyModal');
                    await this.setupSurveyModal();
                }
        }
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    closeModal(){
        this.props.closeClick(false);
        this.setState({ isModalOpen: false });
    }

    handleYes(event){
        this.props.confirmDelete(true);
        this.setState({isModalOpen: false});
        this.closeModal();
    }
    handleNo(event){
        this.props.confirmDelete(false);
        this.setState({isModalOpen: false});
        this.closeModal();
    }
    async handleChange(event){
        this.setState({ isModalOpen: false });
        await this.setState({
            analytics: {
                type: TRACKING.POPUP_SURVEY,
                metadata: {app:this.props.app, result:event.target.value}
            }
        })
        this.handleAnalytics();
        this.props.surveyBack();
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    render() {
            return (
                <Modal id="dialogBox" show={this.props.modalOpen?this.props.modalOpen:this.state.isModalOpen}>
                    {
                        this.props.notificationModal ?
                            <div className="modal-content">
                                <div className={"row modal-body"} >
                                    {/*<span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:50,marginTop:25,float:'right'}} src={closeModalIcon} /></span>*/}
                                    {this.props.warning ?
                                        this.props.slash?
                                            <div className={"col-md-12"}>
                                                <img src={instructionImage} style={{width:'100%'}}/>
                                            </div>
                                            :
                                            <div className={"col-md-12"}>
                                                <img src={fourUngradedWarning} style={{width:'100%'}} />
                                            </div>
                                        :
                                        <div className="section">
                                            { !this.props.infoWarning ?
                                                <h1>{this.props.sectionContent}</h1>
                                                :
                                                <h1>
                                                    <div className="content" style={{textAlign:'left'}}
                                                         dangerouslySetInnerHTML={{__html: this.props.infoWarning}}></div>
                                                </h1>
                                            }
                                        </div>
                                    }
                                    <a onClick={this.closeModal} className="handBtn pull-right">
                                        <span>Close</span>
                                    </a>
                                </div>
                            </div>
                            :this.props.surveyModal ?
                            <div className="modal-content">
                                <div className={"row modal-body"} style={{marginTop:20, marginBottom:20}}>
                                    <h3>{this.state.surveyContent}</h3>
                                    <div>
                                        {this.props.app === 'Homepage'?
                                            <img src={this.state.surveyLogo} style={{width:'auto', height:45, marginTop: 20}}/>
                                            :<img src={this.state.surveyLogo} style={{width:75, height:75, border: '0.1em dashed #000', borderRadius: '25%'}}/>
                                        }
                                    </div>
                                </div>
                                <div className={"row modal-body"} style={{marginTop:20, marginBottom:50}}>
                                    <div className={"col-md-1"}></div>
                                    <div className={"col-md-2"}>
                                        <input type="radio" name="site_name"
                                               value={"1"}
                                               onChange={this.handleChange} />
                                               <img onClick={this.handleChange} src={surveyIcon1} style={{width:'100%',marginTop: 10, cursor:'pointer'}}/>
                                    </div>
                                    <div className={"col-md-2"}>
                                        <input type="radio" name="site_name"
                                               value={"2"}
                                               onChange={this.handleChange} />
                                               <img onClick={this.handleChange} src={surveyIcon2} style={{width:'100%',marginTop: 10, cursor:'pointer'}}/>
                                    </div>
                                    <div className={"col-md-2"}>
                                        <input type="radio" name="site_name"
                                               value={"3"}
                                               onChange={this.handleChange} />
                                               <img onClick={this.handleChange} src={surveyIcon3} style={{width:'100%',marginTop: 10, cursor:'pointer'}}/>
                                    </div>
                                    <div className={"col-md-2"}>
                                        <input type="radio" name="site_name"
                                               value={"4"}
                                               onChange={this.handleChange} />
                                               <img onClick={this.handleChange} src={surveyIcon4} style={{width:'100%',marginTop: 10, cursor:'pointer'}}/>
                                    </div>
                                    <div className={"col-md-2"}>
                                        <input type="radio" name="site_name"
                                               value={"5"}
                                               onChange={this.handleChange} />
                                               <img onClick={this.handleChange} src={surveyIcon5} style={{width:'100%',marginTop: 10, cursor:'pointer'}}/>
                                    </div>
                                    <div className={"col-md-1"}></div>
                                </div>
                            </div>
                            :
                            <div className="modal-content">
                                <div className={"row modal-body"}>
                                    {/*<span style={{cursor:"pointer"}} onClick={this.closeModal}><img style={{width:50,marginTop:25,float:'right'}} src={closeModalIcon} /></span>*/}
                                    <div className="section">
                                        <div>
                                            <img src={warningIcon} style={{width:40,height:40,position:'relative'}} />
                                        </div>
                                        <h1 style={{paddingTop:15}}>{this.props.sectionContent}</h1>
                                        { this.props.backFunction ?
                                            null
                                            :
                                            <p style={{fontFamily:'Open Sans',fontStyle:'sans-serif',fontSize:15,paddingTop:15,paddingBottom:15}}>After deleting, you will not be able to access the student's data.</p>
                                        }
                                        <div className={"col-md-6"}>
                                            <a style={{float:'right'}} onClick={this.handleYes} className="handBtn">
                                                {this.props.backFunction ?
                                                    <span>Leave</span>
                                                    :
                                                    <span>Yes</span>
                                                }
                                            </a>
                                        </div>
                                        <div className={"col-md-6"}>
                                            <a style={{float:'left'}} onClick={this.handleNo} className="handBtn">
                                                {this.props.backFunction ?
                                                    <span>Cancel</span>
                                                    :
                                                    <span>No</span>
                                                }
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
            </Modal>
        )
    }
};

const bindActionToProps = dispatch => {
    return {
        updateFirstLogin: async(results) => await dispatch(updateFirstLogin(results)),
    };
};

const mapStateToProps = state => ({
    firstLogin:state.studentReducer.firstLogin,
});

export default connect(mapStateToProps, bindActionToProps)(DialogBox)
